import React, { useEffect } from "react";
// import { SearchProvider } from "./frontend/Common/Pages/Search/SearchContext";

import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import LandingPage from "./frontend/Pages/Common/LandingPage/LandingPage";
import "./css/App.css";
import CustomerHomePage from "frontend/Pages/Customer/CustomerHomePage";
import AdviserHomePage from "frontend/Pages/Adviser/AdviserHomePage";
import OurServicesPage from "frontend/Pages/OurServicesPage/OurServicesPage";
import RetirementPlanning from "frontend/Pages/OurServicesPage/Services/RetirementPlanning";
import MortagePlanning from "frontend/Pages/OurServicesPage/Services/MortagePlanning";
import InvestmentPlanning from "frontend/Pages/OurServicesPage/Services/InvestmentPlanning";
import CorporatePlanning from "frontend/Pages/OurServicesPage/Services/CorporatePlanning";
import EquityRelease from "frontend/Pages/OurServicesPage/Services/EquityRelease";
import InsuranceProtection from "frontend/Pages/OurServicesPage/Services/InsuranceProtection";
import ScrollToTop from "frontend/Components/ScollToTop/ScrollToTop";
import AboutUsPage from "frontend/Pages/Customer/AboutUsPage";
import ContactUsPage from "frontend/Pages/Common/ContactUsPage/ContactUsPage";
import PrivacyPolicyPage from "frontend/Pages/PrivacyPolicyPage/PrivacyPolicyPage";
import PersonalApproachPage from "frontend/Pages/Adviser/AdviserPersonalApproach";
import SupportPage from "frontend/Pages/Adviser/AdviserSupport";
import TechnologyPage from "frontend/Pages/Adviser/AdviserTechnology";
import AdviserAboutUsPage from "frontend/Pages/Adviser/AdviserAboutUs";
import JoinUsPage from "frontend/Pages/Adviser/AdviserJoinUs";
import EventsPage from "frontend/Pages/Adviser/AdviserEventsPage";
import RosemountInMediaPage from "frontend/Pages/RosemountMedia/RosemountMedia";
import RosemountBlogPage from "frontend/Pages/RosemountMedia/RosemountBlog/RosemountBlog";
import DflipBrochurePage from "frontend/Components/RequestBrochure/dflipBrochure";

const PING_INTERVAL = 300000; // Every 5 minutes (300,000 ms)

const keepServerAwake = () => {
  fetch("https://rosemount-financial-solution-ifa-ltd.onrender.com/api/status")
    .then(() => {
      // console.log("Pinged Render API to keep it awake");
    })
    .catch(() => {
      // console.log("Ping failed, but will retry in 5 mins");
    });
};

function App() {
  // useEffect(() => {
  //   keepServerAwake(); // Ping once when the component mounts
  //   const interval = setInterval(keepServerAwake, PING_INTERVAL);
  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);

  return (
    // <SearchProvider>
    <Router>
      {/* <nav
        >
          <Link to="/">Landing Page</Link>
          <Link to="/test-widget">Test Widget</Link>
        </nav> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/Customer" element={<CustomerHomePage />} />
        <Route path="/Adviser" element={<AdviserHomePage />} />
        <Route path="/OurServices" element={<OurServicesPage />} />
        <Route path="/AboutUs" element={<AboutUsPage />} />
        <Route path="/ContactUs" element={<ContactUsPage />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicyPage />} />
        <Route path="/RosemountInMedia" element={<RosemountInMediaPage />} />
        <Route path="/RosemountBlog" element={<RosemountBlogPage />} />
        <Route
          path="/OurServices/RetirementPlanning"
          element={<RetirementPlanning />}
        />
        <Route
          path="/OurServices/MortgagePlanning"
          element={<MortagePlanning />}
        />
        <Route
          path="/OurServices/InvestmentPlanning"
          element={<InvestmentPlanning />}
        />
        <Route
          path="/OurServices/CorporatePlanning"
          element={<CorporatePlanning />}
        />
        <Route path="/OurServices/EquityRelease" element={<EquityRelease />} />
        <Route
          path="/OurServices/InsuranceProtection"
          element={<InsuranceProtection />}
        />
        <Route
          path="/Adviser/PersonalApproach"
          element={<PersonalApproachPage />}
        />
        <Route path="/Adviser/Brochure" element={<DflipBrochurePage />} />
        <Route path="/Brochure" element={<DflipBrochurePage />} />
        <Route path="/Adviser/Support" element={<SupportPage />} />
        <Route path="/Adviser/Technology" element={<TechnologyPage />} />
        <Route path="/Adviser/AboutUs" element={<AdviserAboutUsPage />} />
        <Route path="/Adviser/AboutUs" element={<AdviserAboutUsPage />} />
        <Route path="/Adviser/JoinUs" element={<JoinUsPage />} />
        <Route path="/Adviser/Events" element={<EventsPage />} />
      </Routes>
    </Router>
    // </SearchProvider>
  );
}

export default App;
